'use client'

import { createContext, useContext, ReactNode } from 'react'

interface Env {
    BASE_URL: string
    DEMO_LINK: string
    PRACTICE_LOGIN_URL: string
    ASSETS_URL: string
    CONTACT_US_FORM_LINK: string
    SANITY_PROJECT_ID: string
    SANITY_DATASET: string
}

const EnvContext = createContext<Env | undefined>(undefined)

export function EnvProvider({ children, env }: { children: ReactNode; env: Env }) {
    return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
}

export function useEnv() {
    const context = useContext(EnvContext)
    if (context === undefined) {
        throw new Error('useEnv must be used within an EnvProvider')
    }
    return context
}
